<template>
  <i
    v-if="tpttPlatform === 'taobao' || tpttPlatform === 'api99'"
    class="iconfont icontaobao traPlatformIcon"
  />
  <i
    v-else-if="tpttPlatform === 'xianyu'"
    class="iconfont iconxianyu traPlatformIcon"
  />
  <i
    v-else-if="tpttPlatform === '1688' || tpttPlatform === '1688tb'"
    class="iconfont iconalibaba traPlatformIcon"
  />
  <i
    v-else-if="tpttPlatform === 'pinduoduo' || tpttPlatform === 'pddtb'"
    class="iconfont iconpinduoduo traPlatformIcon"
  />
  <img
    v-else-if="tpttPlatform === 'weidian'"
    src="/static/images/icon/weidian.svg"
    alt="微店"
    class="traPlatformIcon traPlatformImage"
  >
  <svg
    v-else-if="tpttPlatform === 'tmall'"
    class="svg-icon"
    aria-hidden="true"
    style="font-size: 1.2em;"
  >
    <use xlink:href="#icontianmao3" />
  </svg>
</template>
<script>
export default {
  props: {
    tpttPlatform: String,
  }
}
</script>
<style lang="postcss" scoped>
.traPlatformIcon {
    color: #ed5d2e;
    /* background: #fff; */
    vertical-align: text-top;
    line-height: 1em;
    &.icontianmao {
        color: #eb3340;
    }
    &.iconxianyu {
        color: rgba(255, 216, 77);
    }
    &.iconpinduoduo {
      color: #d0311d;
    }
}
.traPlatformImage {
    width: 1em;
    height: 1em;
    object-fit: contain;
}
</style>
